export const recentSearches = [
  "Claim",
  "Accident",
  "Case Doc",
  "Accident case",
  "Accident case history",
];

export const recentFiles = [
  "VA Insurance Claim.doc",
  "Claim.pdf",
  "Claim.pdf",
  "Claim.pdf",
  "Claim.pdf",
];

export const searchResults = [
  "Claim Result 1",
  "Claim Result 2",
  "Claim Result 3",
];
